import { render, staticRenderFns } from "./instagram.vue?vue&type=template&id=9e797ac6"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9e797ac6')) {
      api.createRecord('9e797ac6', component.options)
    } else {
      api.reload('9e797ac6', component.options)
    }
    module.hot.accept("./instagram.vue?vue&type=template&id=9e797ac6", function () {
      api.rerender('9e797ac6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/instagram.vue"
export default component.exports